import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Platform } from '@app/classes';
import { AuthService } from '@app/services/auth.service';

/**
 * TimeTrackingRedirectionGuard determines where you will be redirected to when
 * you visit /time-tracking
 */
@Injectable()
export class TimeTrackingRedirectionGuard {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        const isTimeTrackingAdmin = this.auth.can(Platform.timeTracking.permission.view);
        const isAssignedToTimeTracking = Boolean(this.auth.employee?.hasModule(Platform.modules.timeTracking));
        const canApproveTimeTrackingEntries = this.auth.employee?.currentUserSupervisesTimeTracking ?? false;

        if (!isTimeTrackingAdmin && !isAssignedToTimeTracking) {
            this.router.navigate(['/dashboard']);
            return false;
        }

        // admin who does not have the time tracking employee module can only see settings
        if (isTimeTrackingAdmin && !isAssignedToTimeTracking) {
            this.router.navigate(['/time-tracking/settings']);
            return false;
        }

        if (isTimeTrackingAdmin || canApproveTimeTrackingEntries) {
            this.router.navigate(['/time-tracking/timesheets']);
            return false;
        }

        this.router.navigate(['/time-tracking/my-timesheet']);

        return false;
    }
}
